// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1d9qZ","topBottomGutter":"Layout_topBottomGutter__3iuBL"};